import { useRef } from "react";
import { Link } from "react-router-dom";
import { motion, useScroll, useTransform } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { Magnetic } from "../site/Motion";

export const CtaBand = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-15%", "15%"]);
  return (
    <section ref={ref} data-testid="cta-band" className="relative overflow-hidden min-h-[80vh] flex items-center">
      <motion.img src="/img/w6.jpg" alt="" aria-hidden style={{ y, scale: 1.3 }} className="absolute inset-0 w-full h-full object-cover" />
      <div className="absolute inset-0 bg-ink/55" />
      <div className="relative mx-auto max-w-[1440px] w-full px-5 sm:px-8 lg:px-12 py-24 text-cream">
        <p className="font-mono text-xs uppercase tracking-[0.3em] text-cream/85">Consulenza per futuri sposi</p>
        <h2 className="mt-6 font-serif text-5xl sm:text-7xl lg:text-8xl leading-[0.95] max-w-4xl">Il vostro giorno, <em>in fiore.</em></h2>
        <div className="mt-10">
          <Magnetic>
            <Link to="/contatti#consulenza" data-testid="cta-band-button" className="inline-flex items-center gap-3 rounded-full bg-cream text-cypress pl-7 pr-2 py-2 text-sm hover:bg-terra hover:text-cream transition-colors duration-300">
              Compila il modulo
              <span className="w-10 h-10 rounded-full bg-cypress text-cream flex items-center justify-center"><ArrowUpRight className="w-4 h-4" /></span>
            </Link>
          </Magnetic>
        </div>
      </div>
    </section>
  );
};
